export default {
    getAllAbilityDetectnOrder: '/api/ability_detectn_order/page', /**能力检测分页**/
    addAbilityDetectnOrder: '/api/ability_detectn_order/add_plan', /**新增能力检测**/
    deleteAbilityDetectnOrder: '/api/ability_detectn_order/del', /**删除能力检测**/
    alterAbilityDetectnOrder: '/api/ability_detectn_order/alter' /**修改设备检测计划**/
}
